import { render, staticRenderFns } from "./MyCoursesSection.vue?vue&type=template&id=076ae5e0"
import script from "./MyCoursesSection.vue?vue&type=script&lang=js"
export * from "./MyCoursesSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports